import { Paper, type SxProps } from "@mui/material";
import type { FC, ReactNode } from "react";

export const Tile: FC<{
  disabled?: boolean;
  onClick: () => void;
  selected?: boolean;
  name: string;
  children?: ReactNode;
  sx?: SxProps;
}> = ({ disabled, onClick, selected, children, name, sx }) => {
  return (
    <Paper
      id={"tile-" + name}
      onClick={() => !disabled && onClick()}
      variant="outlined"
      data-testid={"tile-" + name}
      className={selected ? "selected" : undefined}
      sx={{
        borderColor: selected ? "primary.main" : null,
        borderWidth: selected ? 3 : null,
        height: 150,
        width: 150,
        p: 1,
        opacity: disabled ? 0.5 : null,
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        "&:hover": {
          cursor: disabled ? null : "pointer",
          opacity: disabled ? null : 0.75,
        },
        ...(sx ? sx : {}),
      }}
    >
      {children}
    </Paper>
  );
};
